module.exports = __webpack_public_path__ + "img/network_on.c4479525.svg";